module.exports = __webpack_public_path__ + "img/hotnew.3e3c688c.png";